import { Button, Col, Container, Navbar, NavbarToggler } from "reactstrap";
import React from "react";
import BackButton from "../../../BackButton";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Index = function Index(_ref) {
  var price = _ref.price,
      toggleModal = _ref.toggleModal;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("header", {
      children: /*#__PURE__*/_jsx(Navbar, {
        color: "white",
        light: true,
        dark: false,
        fixed: "top",
        expand: "lg",
        className: "shadow",
        children: /*#__PURE__*/_jsxs(Container, {
          fluid: true,
          children: [/*#__PURE__*/_jsx(Col, {
            xs: 2,
            className: "text-left pl-0",
            children: /*#__PURE__*/_jsx(BackButton, {})
          }), /*#__PURE__*/_jsx(Col, {
            xs: 8,
            className: "text-center mobile-cottage-search-menu",
            children: /*#__PURE__*/_jsxs(Button, {
              className: "font-weight-bold",
              size: "sm",
              onClick: function onClick() {
                return toggleModal();
              },
              color: "light",
              children: [/*#__PURE__*/_jsx("i", {
                className: "fas fa-calendar-alt mobile-cottage-search-menu-icon text-primary"
              }), price && price.price && /*#__PURE__*/_jsx(_Fragment, {
                children: "Wijzig trip"
              }), (!price || !price.price) && /*#__PURE__*/_jsx(_Fragment, {
                children: "Kies een trip"
              })]
            })
          }), /*#__PURE__*/_jsx(Col, {
            xs: 2,
            className: "text-right pr-0",
            children: /*#__PURE__*/_jsx(NavbarToggler, {
              onClick: function onClick() {
                return setCollapsed(!collapsed);
              },
              className: "navbar-toggler-right",
              children: /*#__PURE__*/_jsx("i", {
                className: "fa fa-bars"
              })
            })
          })]
        })
      })
    })
  });
};

export default Index;